import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const NumberPhone = (props) => {
  const { numberPhone } = props;

  const [phone, setPhone] = useState(numberPhone) ;
  
  return (
      <td>{ phone }</td>
  )
}

export default NumberPhone;